define('drops/tweetDrop/tweetDrop',[
    'jquery',
    'lq/drop'
], function ($, Drop) {
    'use strict';

    function Twitter(options) {
        Drop.call(this, $('<div/>'), options);

        this.$element
	        .addClass('boxToBorderSize tweet-drop')
	        .css({
	            whiteSpace: 'pre-wrap'
	        });
    };

    Drop.extend(Twitter, Drop);

    Twitter.typeName = 'Twitter';

    Twitter.prototype.preRender = function () {
        this.applyPosition();
    };

    Twitter.prototype.postRender = function () {
        this.renderTwitter();
    };

    Twitter.prototype.renderTwitter = function () {
        this.$element.empty();

        $('<a />')
            .addClass('twitter-timeline')
            .attr('href', this.data.username ? 'http://twitter.com/' + this.data.username : '#')
            .attr('data-widget-id', this.data.widgetId)
            .text('Tweets by @' + this.data.username)
            .prependTo(this.$element);

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0], p = /^http:/.test(d.location) ? 'http' : 'https';
            js = d.createElement(s);
            js.id = id;
            js.src = p + "://platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "twitter-wjs"));
    };
    
    return Twitter;
});
